import { inject, Pipe, PipeTransform } from '@angular/core';
import { LocalizedTextDto } from '../dtos/localized-text.dto';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
  name: 'localizedText'
})
export class LocalizedTextPipe implements PipeTransform {

  translocoService = inject(TranslocoService);

  transform(localizedTextDtos: LocalizedTextDto[] | null | undefined): string | null {
    if (!localizedTextDtos || localizedTextDtos.length === 0) {
      return null;
    }

    const language = this.translocoService.getActiveLang();
    const localizedTextDto = localizedTextDtos.find(text => text.language === language);

    return localizedTextDto?.value ?? null;
  }
}
